import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { doctorInfo } from '../../data/mock';

const WhatsAppButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  // Show button after scrolling a bit
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 200);
    };

    window.addEventListener('scroll', handleScroll);
    // Show initially after 2 seconds
    const timer = setTimeout(() => setIsVisible(true), 2000);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);

  const phoneNumber = doctorInfo.phone.replace(/\s/g, '').replace('+', '');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=Bonjour Dr LOUNIS KHODJA, je souhaiterais prendre rendez-vous.`;

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Chat bubble */}
      {isOpen && (
        <div className="absolute bottom-16 right-0 mb-2 animate-fade-in-up">
          <div className="bg-white rounded-2xl shadow-2xl p-4 w-72 border border-gray-100">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center">
                <MessageCircle className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="font-medium text-gray-900 text-sm">Dr LOUNIS KHODJA</p>
                <p className="text-xs text-green-600">Répond généralement rapidement</p>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-4">
              Bonjour ! Comment puis-je vous aider ? Cliquez ci-dessous pour nous contacter sur WhatsApp.
            </p>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-green-500 hover:bg-green-600 text-white text-center py-3 rounded-xl font-medium transition-colors"
            >
              Démarrer la conversation
            </a>
          </div>
          {/* Triangle pointer */}
          <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white border-r border-b border-gray-100 transform rotate-45" />
        </div>
      )}

      {/* Main button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 ${
          isOpen 
            ? 'bg-gray-700 hover:bg-gray-800 rotate-90' 
            : 'bg-green-500 hover:bg-green-600 animate-pulse-soft hover:scale-110'
        }`}
        aria-label="Contacter sur WhatsApp"
      >
        {isOpen ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <MessageCircle className="w-6 h-6 text-white" />
        )}
      </button>

      {/* Notification badge */}
      {!isOpen && (
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center">
          <span className="text-white text-xs">1</span>
        </span>
      )}
    </div>
  );
};

export default WhatsAppButton;
